import _ from 'lodash';

export function makeCacheable(func, options = {}) {
	const cache = [];

	function writeCache(identity, result, maxCacheEntries) {
		cache.push({ identity, result });
		if (cache.length > maxCacheEntries) {
			cache.shift();
		}
	}

	function readCache(targetIdentity) {
		return _.find(cache, ({ identity }) => {
			let isEqual = true;
			for (let i = 0, len = identity.length; i < len; i++) {
				if (identity[i] != targetIdentity[i]) {
					isEqual = false;
					break;
				}
			}
			return isEqual;
		});
	}

	return function (...args) {
		let cached = readCache(args);
		if (cached) {
			return cached.result;
		}
		let result = func.apply(options.context || null, args);
		writeCache(args, result, options.maxEntries || 100);
		return result;
	};
}
